"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const React = require("react");
const ConfigContext_1 = require("../../contexts/ConfigContext");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const SharedTypes_1 = require("../../models/SharedTypes");
class Header extends React.PureComponent {
    constructor(props) {
        super(props);
        this._updateDimensionDebouncer = () => {
            if (this._debounce) {
                window.clearTimeout(this._debounce);
            }
            this._debounce = window.setTimeout(() => {
                this._updateDimension();
            }, 100);
        };
        this._updateDimension = () => {
            this.setState(() => {
                let browserSupportDimension = SharedTypes_1.defaultDimension;
                if (this._browserSupportElement) {
                    browserSupportDimension = {
                        height: this._browserSupportElement.clientHeight,
                        width: this._browserSupportElement.clientWidth,
                    };
                }
                return {
                    browserSupportDimension,
                };
            });
        };
        this._setBrowserSupport = (element) => {
            if (element) {
                this._browserSupportElement = element;
            }
        };
        this.state = {
            browserSupportDimension: SharedTypes_1.defaultDimension,
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this._updateDimensionDebouncer);
        this._updateDimension();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this._updateDimensionDebouncer);
        delete this._browserSupportElement;
    }
    renderJoinOnWebDisclaimer() {
        // Join on web only available in desktop
        if (EnvironmentHelper_1.deviceType !== EnvironmentHelper_1.DeviceTypes.Desktop || EnvironmentHelper_1.canJoinOnWeb) {
            return null;
        }
        let param;
        switch (EnvironmentHelper_1.os) {
            case EnvironmentHelper_1.OperatingSystems.MacOS:
                param = { list_supported_browser: bew_localization_1.localizer.getString('Meetings.txt_list_supported_browser_macos') };
                break;
            case EnvironmentHelper_1.OperatingSystems.Win:
            case EnvironmentHelper_1.OperatingSystems.WinRT:
                param = { list_supported_browser: bew_localization_1.localizer.getString('Meetings.txt_list_supported_browser_win') };
                break;
            case EnvironmentHelper_1.OperatingSystems.Linux:
            default:
                param = { list_supported_browser: bew_localization_1.localizer.getString('Meetings.txt_list_supported_browser_linux') };
                break;
        }
        return React.createElement("div", { className: 'outer', style: { minHeight: this.state.browserSupportDimension.height, width: '100%' } },
            React.createElement("div", { key: 'browser-compat', className: 'header dark', ref: this._setBrowserSupport, style: { padding: '1rem 2rem' } },
                React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => React.createElement(react_1.Image, { style: { width: '1.5rem', height: '1.5rem' }, src: `${configContext.basePath}/images/icons/warning.svg`, onLoad: this._updateDimensionDebouncer })),
                React.createElement(react_1.Text, { size: 'medium', styles: { alignSelf: 'flex-end', marginLeft: '1rem' }, weight: 'semibold' }, bew_localization_1.localizer.getString('Meetings.txt_banner_unsupported_browser', param))));
    }
    render() {
        return React.createElement(React.Fragment, null, this.renderJoinOnWebDisclaimer());
    }
}
exports.Header = Header;
